export const Cats = ["Envelopes", "Letterheads", "Business Cards"];
